import { ArrowOutward, Call, LocationOnOutlined } from '@mui/icons-material';
import teamPhoto from '../../shared/assets/images/valsta-team.webp';
import './styles.css';

const Hero = () => (
  <section className="home-hero" aria-labelledby="hero-title">
    <div className="container hero-grid">
      <div className="hero-copy">
        <p className="eyebrow">Valsta Tandläkarklinik · Märsta</p>
        <h1 id="hero-title">Tandvård nära dig.<br /><span>Med dig i fokus.</span></h1>
        <p className="hero-description">Från din första undersökning till nästa steg för ditt leende. Välkommen till oss på Valstavägen – vi hjälper dig att hitta rätt tandvård.</p>
        <div className="hero-actions">
          <a className="button button-primary" href="https://www.muntra.com/valsta-tandlakarklinik/c/4519?language=sv" target="_blank" rel="noopener noreferrer">Boka tid online <ArrowOutward fontSize="small" /></a>
          <a className="button button-secondary" href="tel:+46859440060"><Call fontSize="small" />08-594 400 60</a>
        </div>
        <p className="hero-booking-note">Boka enkelt via Muntra. Nya patienter är välkomna.</p>
      </div>
      <div className="hero-photo-wrap">
        <img className="hero-photo" src={teamPhoto} alt="Teamet på Valsta Tandläkarklinik välkomnar dig i receptionen" width="1200" height="900" />
        <div className="hero-location"><span className="hero-location-icon"><LocationOnOutlined /></span><div><strong>Vi finns här för dig</strong><span>Valstavägen 32E, Märsta</span></div></div>
      </div>
    </div>
  </section>
);
export default Hero;
